import nanoid from 'nanoid';
import { parseDocumentTitle } from '../utils/utilsGlobal';
import { hideAlert as hideAlertUI } from '../components';
import {
  SET_AUTH_TOKEN,
  SET_IS_LOGGED_IN,
  SET_CURRENT_OPERATOR,
  SET_REMINDER_TYPES,
  SET_WORK_HOURS_SCHEDULER_REASONS,
  SHOW_ALERT,
  HIDE_ALERT,
  SET_COMPANIES,
  SET_CURRENT_ROOM,
  SET_CURRENT_ROOMS_BY_FILTER,
  SET_CURRENT_ROOM_FILTER,
  SET_CURRENT_ROOM_SEARCH_TERM,
  SET_CURRENT_COMPANY,
  SET_CURRENT_COMPANY_OPERATORS,
  SET_TOTAL_UNREAD_COUNT,
  SET_DOCUMENT_TITLE_BASE,
  SET_CURRENT_MESSAGES,
  SET_WORK_HOURS_SCHEDULER_IS_WORKING,
  SET_NEW_VERSION_AVAILABLE,
  SET_MOBILE_ROOM_MENU_ENABLED,
  SET_MOBILE_ROOM_INFO_ENABLED,
  SET_CURRENT_ROOMS_BY_SEARCH_TERM,
  SET_WORK_HOURS_SCHEDULER_CAN_SWITCH_OFF,
  SET_CASE_CLOSE_REASON,
} from './actionTypes';


/**
 * One-liner to simplify actions code
 * @returns {{payload: *, type: *}}
 */
function sendAction(type, payload){
  return { type, payload };
}

export function setCompanies(companies) {
  return sendAction(SET_COMPANIES, { companies });
}

export function setCurrentRoomFilter(currentRoomFilter) {
  return sendAction(SET_CURRENT_ROOM_FILTER, { currentRoomFilter });
}

export function setCurrentRoomSearchTerm(currentRoomSearchTerm) {
  return sendAction(SET_CURRENT_ROOM_SEARCH_TERM, { currentRoomSearchTerm });
}

export function setReminderTypes(reminderTypes) {
  return sendAction(SET_REMINDER_TYPES, { reminderTypes });
}

export function setReasonTypes(reasonTypes) {
  return sendAction(SET_CASE_CLOSE_REASON, { reasonTypes });
}

export function setCurrentCompany(currentCompany) {
  return sendAction(SET_CURRENT_COMPANY, { currentCompany });
}

export function setCurrentCompanyOperators(currentCompanyOperators) {
  return sendAction(SET_CURRENT_COMPANY_OPERATORS, { currentCompanyOperators });
}

export function setCurrentRoom(currentRoom) {
  return sendAction(SET_CURRENT_ROOM, { currentRoom });
}

export function setCurrentRoomsByFilter(currentRoomsByFilter) {
  return sendAction(SET_CURRENT_ROOMS_BY_FILTER, { currentRoomsByFilter });
}

export function setCurrentRoomsBySearchTerm(currentRoomsBySearchTerm) {
  return sendAction(SET_CURRENT_ROOMS_BY_SEARCH_TERM, { currentRoomsBySearchTerm });
}

export function setTotalUnreadCount(totalUnreadCount) {
  return sendAction(SET_TOTAL_UNREAD_COUNT, { totalUnreadCount });
}

export function setDocumentTitleBase(documentTitleBase) {
  const { counter } = parseDocumentTitle();
  document.title = (counter ? `(${counter}) ` : '') + documentTitleBase;
  return sendAction(SET_DOCUMENT_TITLE_BASE, { documentTitleBase });
}

export function setCurrentMessages(messages){
  return sendAction(SET_CURRENT_MESSAGES, { messages });
}

export function setCurrentOperator(currentOperator){
  return sendAction(SET_CURRENT_OPERATOR, { currentOperator });
}

export function setAuthToken(authToken){
  return sendAction(SET_AUTH_TOKEN, { authToken });
}

export function setIsLoggedIn(isLoggedIn){
  return sendAction(SET_IS_LOGGED_IN, { isLoggedIn });
}

export function showAlert({ text, hideAfter = 3000, dontAutoHide = false, type = 'info' }){
  const id = nanoid();
  if (!dontAutoHide) {
    setTimeout(() => {
      hideAlertUI(id);
    }, hideAfter);
  }
  return sendAction(SHOW_ALERT, {
    id,
    text,
    hideAfter,
    dontAutoHide,
    type,
  });
}

export function hideAlert(alertId){
  return sendAction(HIDE_ALERT, { alertId });
}

export function setWorkHoursSchedulerReasons(workHoursSchedulerReasons) {
  return sendAction(SET_WORK_HOURS_SCHEDULER_REASONS, { workHoursSchedulerReasons });
}

export function setWorkHoursSchedulerIsWorking(workHoursSchedulerIsWorking){
  return sendAction(SET_WORK_HOURS_SCHEDULER_IS_WORKING, { workHoursSchedulerIsWorking });
}

export function setWorkHoursSchedulerCanSwitchOff(workHoursSchedulerCanSwitchOff){
  return sendAction(SET_WORK_HOURS_SCHEDULER_CAN_SWITCH_OFF, { workHoursSchedulerCanSwitchOff });
}

export function setNewVersionAvailable(newVersionAvailable){
  return sendAction(SET_NEW_VERSION_AVAILABLE, { newVersionAvailable });
}

export function setMobileMenuEnabled(isMobileMenuEnabled){
  return sendAction(SET_MOBILE_ROOM_MENU_ENABLED, { isMobileMenuEnabled });
}

export function setMobileSidebarEnabled(isMobileSidebarEnabled){
  return sendAction(SET_MOBILE_ROOM_INFO_ENABLED, { isMobileSidebarEnabled });
}
